"use client";

import { css, styled } from "styled-components";

export const TableLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;

  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const Row = styled.div<{ $isDisableEdit: boolean }>`
  display: flex;
  align-items: center;
  align-self: stretch;

  border-bottom: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);

  &:last-child {
    border-bottom: none;
  }

  &:hover:not($isDisableEdit) {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
  }

  ${({ $isDisableEdit }) =>
    $isDisableEdit &&
    css`
      background: var(--Color-Common-Bg-Disabled, #cbd0d8);
      cursor: not-allowed;
    `}
`;

export const BodyCell = styled.div<{ $maxWidth?: string; $minWidth?: string }>`
  display: flex;
  max-width: ${({ $maxWidth }) => $maxWidth};
  min-width: ${({ $minWidth }) => $minWidth};
  padding: var(--Spacing-8, 0.8rem) var(--Spacing-4, 0.4rem);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-4, 0.4rem);
  flex: 1 0 0;

  position: relative;

  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Interactive-Secondary, #fff);

  &:last-child {
    border-right: none;
  }
`;

export const BodyCellValue = styled.div`
  display: flex;
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  align-self: stretch;

  overflow: hidden;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  text-overflow: ellipsis;

  font-family: var(--font-pt-serif);
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 130%;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  width: 100%;
`;
